import { changeConnectionType, changeEndDate } from 'actions/import';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getImportType } from 'selectors/import';
import { useSelector } from 'store';

const ImportTypeSelection: React.FC = () => {
  const dispatch = useDispatch();

  const type = useSelector(getImportType);

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.value === 'livestream' || e.target.value === 'lookback') {
      dispatch(changeConnectionType(e.target.value));
      if (e.target.value === 'livestream') {
        dispatch(changeEndDate(''));
      }
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div>
        <span>Type of connection</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div>
        <div className="flex flex-col gap-2">
          <label htmlFor="livestream" className="flex justify-start items-center w-1/2">
            <input
              type="radio"
              id="livestream"
              name="type"
              value="livestream"
              onChange={handleTypeChange}
              checked={type === 'livestream'}
              className="input-radio"
            />
            <span className="text ml-1">Livestream</span>
          </label>
          <label htmlFor="lookback" className="flex justify-start items-center w-1/2">
            <input
              type="radio"
              data-testid="lookback-radio"
              className="input-radio"
              id="lookback"
              name="type"
              value="lookback"
              onChange={handleTypeChange}
              checked={type === 'lookback'}
            />
            <span className="text ml-1">Lookback</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ImportTypeSelection;
